import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SignaturePad = ({ onSave, busy }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    c.width = r.width * 2; c.height = r.height * 2;
    const ctx = c.getContext("2d");
    ctx.scale(2, 2); ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#111";
    ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, r.width, r.height);
  }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setDirty(true); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; const ctx = c.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height); setDirty(false); };
  const save = () => ref.current.toBlob((b) => onSave(b), "image/png");
  return (
    <div className="space-y-2" data-testid="signature-pad">
      <canvas ref={ref} className="w-full h-40 rounded-2xl border-2 border-dashed bg-white touch-none cursor-crosshair"
        onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid="signature-canvas" />
      <p className="text-[11px] text-muted-foreground text-center">Anggota tanda tangan di dalam kotak</p>
      <div className="flex gap-2">
        <Button type="button" variant="outline" className="h-10 rounded-full flex-1" onClick={clear} disabled={!dirty} data-testid="signature-clear"><Eraser className="h-4 w-4 mr-1" />Hapus</Button>
        <Button type="button" className="h-10 rounded-full flex-1" onClick={save} disabled={!dirty || busy} data-testid="signature-save">{busy ? "Menyimpan..." : "Simpan Tanda Tangan"}</Button>
      </div>
    </div>
  );
};
